import classnames from 'classnames';
import PropTypes  from 'prop-types';
import React      from 'react';

export default class SaveOnChange extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state    = {
      inProgress: false
    };
  }

  async onChange(value) {
    const { save } = this.props;
    try {
      this.setState({ inProgress: true });
      await save(value);
    } finally {
      this.setState({ inProgress: false });
    }
  }

  render() {
    const { inProgress } = this.state;
    const { className }  = this.props;
    const classNames     = classnames(className, inProgress ? 'in-progress' : null);

    return (
      <section className={classNames}>
        {this.props.children(this.onChange, inProgress)}
      </section>
    );
  }
}


SaveOnChange.propTypes = {
  save: PropTypes.func.isRequired
};
